// SimpleBarChart.tsx
import React from "react";
import { SimpleBarChartProps } from "../types/revenue.types";

export const SimpleBarChart: React.FC<SimpleBarChartProps> = ({
  data,
  labelKey,
  valueKey,
  height = 300,
  color = "#10b981",
}) => {
  if (data.length === 0) {
    return (
      <div
        style={{
          height,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#6b7280",
          fontSize: "14px",
        }}
      >
        No data available
      </div>
    );
  }

  const maxValue = Math.max(...data.map((d: any) => Number(d[valueKey]) || 0));

  return (
    <div
      style={{
        height,
        padding: "20px 0",
        display: "flex",
        alignItems: "end",
        gap: "12px",
      }}
    >
      {data.slice(0, 10).map((item: any, index: number) => {
        const itemValue = Number(item[valueKey]) || 0;
        const barHeight = (itemValue / maxValue) * (height - 80);

        return (
          <div
            key={index}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              flex: 1,
              minWidth: "60px",
            }}
          >
            <div
              style={{
                height: `${Math.max(barHeight, 20)}px`,
                backgroundColor: color,
                width: "100%",
                borderRadius: "2px 2px 0 0",
                transition: "all 0.3s ease",
                position: "relative",
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "center",
                paddingTop: "4px",
              }}
            >
              <div
                style={{
                  fontSize: "12px",
                  color: "white",
                  fontWeight: "600",
                  textShadow: "0 1px 2px rgba(0,0,0,0.3)",
                }}
              >
                {itemValue}
              </div>
            </div>
            <div
              style={{
                fontSize: "11px",
                color: "#4b5563",
                textAlign: "center",
                marginTop: "8px",
                wordBreak: "break-word",
                lineHeight: "1.2",
                maxWidth: "100%",
              }}
            >
              {item[labelKey]}
            </div>
          </div>
        );
      })}
    </div>
  );
};
